// import React from "react";
// import "../assets/css/style.css"; 
// import "@fortawesome/fontawesome-free/css/all.min.css";

// const WhatsappButton = () => {
//   return (
//     <a
//       href="https://api.whatsapp.com/send?phone=9848194446"
//       className="float"
//       target="_blank"
//       rel="noopener noreferrer"
//     >
//       <i className="fab fa-whatsapp my-float"></i>
//     </a>
//   );
// };
// export default WhatsappButton;



import React from "react";
// import "https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../assets/css/style.css";

const WhatsAppButton = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=8977060666"
      className="float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fab fa-whatsapp my-float"></i>
    </a>
  );
};
export default WhatsAppButton;